import { render, staticRenderFns } from "./AcademyLearningMapUnits.vue?vue&type=template&id=6928e28b&scoped=true&lang=pug&"
import script from "./AcademyLearningMapUnits.vue?vue&type=script&lang=ts&"
export * from "./AcademyLearningMapUnits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6928e28b",
  null
  
)

export default component.exports